import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink as HLink } from 'react-router-hash-link';

class Header extends Component {

   render() {
      let imgattr = 'image'

      return (
      <div>
      <header id="home">
         <nav className="navbar navbar-inverse navbar-expand-lg header-nav fixed-top light-header">
            <div className="container">
               <Link className="navbar-brand d-flex align-items-center" to="/">
                  <img
                     src={process.env.PUBLIC_URL + "/assets/img/proto.ai.png"}
                     alt="protoAI"
                     style={{height: '40px', width: 'auto', marginRight: '10px'}}
                  />
                  <span className="brand-text font-weight-bold text-primary">protoAI</span>
               </Link>
               <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCodeply">
               <i className="icofont-navigation-menu"></i>
               </button>
               <div className="collapse navbar-collapse" id="navbarCodeply">
                  <ul className="nav navbar-nav ml-auto">
                     <li><Link className="nav-link" to="/">ホーム</Link></li>
                     <li><Link className="nav-link" to="/services">サービス</Link></li>
                     <li><Link className="nav-link" to="/pricing">料金</Link></li>
                     <li><Link className="nav-link" to="/flow">導入の流れ</Link></li>
                     <li><Link className="nav-link" to="/cases">事例</Link></li>
                     <li><Link className="nav-link" to="/about">会社情報</Link></li>
                     <li><Link className="nav-link" to="/faq">FAQ</Link></li>
                     <li><Link className="nav-link btn btn-default btn-sm btn-filled ml-2" to="/contact">お問い合わせ</Link></li>
                  </ul>
               </div>
            </div>
         </nav>
      </header>      
      </div>

    );
   }
}

export default Header;
